export enum ThemeType {
  Dark = "darkMode",
  Light = "lightMode",
}

export type ThemeContext = {
  current: ThemeType;
  set: (theme: ThemeType) => void;
};
